import {
  GET_ADL_ACTIVITIES_FAIL,
  GET_ADL_ACTIVITIES_REQUEST,
  GET_ADL_ACTIVITIES_SUCCESS,
  GET_APPOINTMENTS_FAIL,
  GET_APPOINTMENTS_REQUEST,
  GET_APPOINTMENTS_SUCCESS,
  GET_TO_APPOINTMENTS_FAIL,
  GET_TO_APPOINTMENTS_REQUEST,
  GET_TO_APPOINTMENTS_SUCCESS,
  GET_UNREVIEWED_LAB_REPORTS_FAIL,
  GET_UNREVIEWED_LAB_REPORTS_REQUEST,
  GET_UNREVIEWED_LAB_REPORTS_SUCCESS,
  GET_UPCOMING_APPOINTMENTS_FAIL,
  GET_UPCOMING_APPOINTMENTS_REQUEST,
  GET_UPCOMING_APPOINTMENTS_SUCCESS,
  MARKED_ALL_LAB_REPORTS_FAIL,
  MARKED_ALL_LAB_REPORTS_REQUEST,
  MARKED_ALL_LAB_REPORTS_SUCCESS,
  MARKED_LAB_REPORT_FAIL,
  MARKED_LAB_REPORT_REQUEST,
  MARKED_LAB_REPORT_SUCCESS,
  RESET_MARKED_LAB_REPORT,
} from "../../assets/constants/appointment";

// GET ADL ACTIVITES REDUCER
export const getAdlActivitiesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ADL_ACTIVITIES_REQUEST:
      return { loading: true };
    case GET_ADL_ACTIVITIES_SUCCESS:
      return { loading: false, adlActivities: action.payload };
    case GET_ADL_ACTIVITIES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET APPOINTMENTS BY DATE RANGE REDUCER
export const getAllAppointments = (state = {}, action) => {
  switch (action.type) {
    case GET_APPOINTMENTS_REQUEST:
      return { loading: true };
    case GET_APPOINTMENTS_SUCCESS:
      return { loading: false, allAppointments: action.payload };
    case GET_APPOINTMENTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET TO APPOINTMENTS BY DATE RANGE REDUCER
export const getToAppointmentsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TO_APPOINTMENTS_REQUEST:
      return { loading: true };
    case GET_TO_APPOINTMENTS_SUCCESS:
      return { loading: false, toAppointments: action.payload };
    case GET_TO_APPOINTMENTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET UPCOMING APPOINTMENTS BY DATE RANGE REDUCER
export const getUpcomingAppointmentsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_UPCOMING_APPOINTMENTS_REQUEST:
      return { loading: true };
    case GET_UPCOMING_APPOINTMENTS_SUCCESS:
      return { loading: false, upcomingAppointments: action.payload };
    case GET_UPCOMING_APPOINTMENTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET UNREVIEWED LAB REPORTS REDUCER
export const getUnreviewedLabReportsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_UNREVIEWED_LAB_REPORTS_REQUEST:
      return { loading: true };
    case GET_UNREVIEWED_LAB_REPORTS_SUCCESS:
      return { loading: false, unreviewedLabReports: action.payload };
    case GET_UNREVIEWED_LAB_REPORTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// MARKED REVIEWED LAB REPORT REDUCER
export const markedLabReportReviewedReducer = (state = {}, action) => {
  switch (action.type) {
    case MARKED_LAB_REPORT_REQUEST:
      return { loading: true };
    case MARKED_LAB_REPORT_SUCCESS:
      return { loading: false, labReportReviewed: action.payload };
    case MARKED_LAB_REPORT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_MARKED_LAB_REPORT:
      return {};
    default:
      return state;
  }
};

// MARKED ALL REVIEWED LAB REPORTs REDUCER
export const markedAllLabReportsReviewedReducer = (state = {}, action) => {
  switch (action.type) {
    case MARKED_ALL_LAB_REPORTS_REQUEST:
      return { loading: true };
    case MARKED_ALL_LAB_REPORTS_SUCCESS:
      return { loading: false, allLabReportsReviewed: action.payload };
    case MARKED_ALL_LAB_REPORTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
